
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const HazyDay = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="HazyDay" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M2 13h12v1H2zm-2 2h16v1H0zM7.5 0h1v3h-1zM13 7.5h3v1h-3zm-13 0h3v1H0zm1.985026135-4.803521445l.7070203865-.7071931653 2.1215794959 2.1210611596-.7070203865.7071931653zm9.1972663976 1.4099002852L13.3035388268 1.98498445l.7071314634.7070820981-2.1212462942 2.1213943903z" />
  <path fill={colorArray[0]} className="color0"  d="M12 8a4 4 0 10-6.618 3H0v1h16v-1h-5.382A3.972 3.972 0 0012 8zm-4 3a3 3 0 113-3 3 3 0 01-3 3z" />
</svg>
    </HvIconBase>
)};

HazyDay.propTypes = HvIconBase.propTypes;

export default HazyDay;